var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentDiv',[_c('PageTitle',[_vm._v("Join Live Stream")]),_c('p',[_vm._v("To join a live video stream simply choose a stream from the dropdown once it has been shared with you.")]),_c('PageTitleDivider'),_c('VideoFeedDiv',[_vm._v("Feed")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }